import { ParentModule } from './../ParentClass/parent-module';
import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ReservationService } from '../../trip-reservations/reservations.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { IDataChangeStatus } from '../../../core/interfaces/change-status.interface';
import { T2CardComponent } from '../../../trip2-theme/components/t2-card/t2-card.component';
import { ICancelReason, IResponseCancelTrips } from '../../../core/interfaces/cancel-reason.interface';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-masive-cancel-trips',
  templateUrl: './masive-cancel-trips.component.html',
  styleUrls: ['./masive-cancel-trips.component.scss']
})
export class MasiveCancelTripsComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  @Input() trips: number[] = [];
  @Output() successCancel:
    EventEmitter<{success: boolean, response: IResponseCancelTrips}> =
    new EventEmitter<{success: boolean, response: IResponseCancelTrips}>();
  @ViewChild('modalCancelTrips') private modalCancelTrips: T2CardComponent;
  public form: FormGroup;
  public cancelReason: ICancelReason[] = [];
  private subscriptions: Subscription[] = [];
  constructor(
    private service: ReservationService,
    private _fb: FormBuilder,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-masive-cancel-trips', Inject);
    this.createForm();
    this.subscriptions.push(this.service.getCancelReason().subscribe(
        (data: ICancelReason[]) => {
          this.cancelReason = data;
        }
    ));
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
  }
  private createForm(): void {
    this.form = this._fb.group({
      dataid: 7,
      dataauxid: ['', [Validators.required]],
      actualpickup: '',
      tripstochange: '',
      allLegs: false
    });
  }

  onCalcelTrips(): void {
    this.swalCancelTrips('Are you sure', `Are you sure you want to Cancel the selected ${this.trips.length} trips?`).then((result) => {
      if (result.value) {
        if (this.isAllowedAction('CancelAllLegs')) {
          this.swalCancelTrips('Cancel Trips', 'Do you want to cancel all legs of this reservation?').then((res) => {
            if (res.value) {
              this.setValueAllLegs(true);
            } else {
              this.setValueAllLegs(false);
            }
          });
          return;
        }
        this.setValueAllLegs(false);
      }
    });
  }

  setValueAllLegs(legs: boolean) {
    this.form.get('allLegs').setValue(legs);
    this.cancelTrips();
    this.modalCancelTrips.close();
  }

  swalCancelTrips(title: string, text: any) {
    return this.sweetAlertHelper.createCustomAlert({
      title: title,
      text: text,
      type: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#3085d6',
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No!',
      reverseButtons: true,
    });
  }

  private cancelTrips(): void {
    this._loading.show();
    this.subscriptions.push(this.service.changeStatusTrips(this.generateData()).subscribe(
        (success: IResponseCancelTrips) => {
          this.successCancel.emit({success: true, response: success});
          this._loading.hiden();
          this.buildViewErrors(success.tripschangeresponse);
        },
      error => {
        this.successCancel.emit({success: false, response: error});
        this._loading.hiden();
        this.messageCancel(true,
          `${error.message ? error.message : 'Error when canceling trips'}`);
      }
    ));
  }
  /**
   * @description genera la data para el cambio de estatus
   */
  private generateData(): IDataChangeStatus {
    const data: IDataChangeStatus = this.form.getRawValue();
    data.tripstochange = this.trips;
    return data;
  }
  /**
   * @description
   */
  public onCloseModal(event: {isOpen: boolean, isMinimized: boolean}): void {
    if (!event.isOpen) {this.form.get('dataauxid').setValue(''); }
  }
  private messageCancel(error: boolean, text: string): void {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Cancel Trips',
      text: text,
      type: error ? 'error' : 'success',
    });
  }

  buildViewErrors(tripsArg: any) {
    const tripsErrors = [];
    const tripsSuccessful = [];
    tripsArg.forEach(element => {
      if (!element.changesuccessfull) {
        tripsErrors.push(element);
      } else {
        tripsSuccessful.push(element);
      }
    });

    let messages = '';
    tripsErrors.forEach(element => {
      messages +=
        `<div>
        <p><strong>
          Reservation: ${element.consecutive ? element.consecutive : 'No Return'}
        </p></strong>
        <p>${element.error}</p>
        </div>`;
    });
    const message = tripsSuccessful.length > tripsErrors.length ? 'Trip Success' : 'Trips Errors';

    this.sweetAlertHelper.createCustomAlert({
      title: `<strong>${message}</strong>`,
      html: `
        <div class="color-success">Successful Trips: <strong>${tripsSuccessful.length}</strong><div>
        <div class="color-danger">
          Error Trips: <strong>${tripsErrors.length}</strong>
        <div>
        <div class="margin-t-10"><strong>Details of Fails</strong><div>
        <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
          ${messages}
        </div>
      `,
      type: tripsSuccessful.length > tripsErrors.length ? 'success' : 'error',
      showCancelButton: false,
      confirmButtonText: 'Accept',
      cancelButtonText: 'Cancel'
    }).then();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/masive-cancel-trips/masive-cancel-trips.component.ts